import httpService from '../httpService';
import { InvoiceData, PaymentDetails } from '../../types/payments';
import { SubscriptionType } from '../../types/misc';
import { store } from '../../redux/store';
import { RootState } from '../../redux/reducers';


export const subscriptionService = {
  prepareSubscription: async (subscriptionType: SubscriptionType): Promise<{
    status: 'subscription_already_active' | 'subscription_prepared';
    clientSecret?: string;
    customerId?: string;
  }> => {
    const { selectedCommunity } = (store.getState() as RootState).application;
    const res = await httpService.post(`/networks/communities/${selectedCommunity}/subscription/prepare`, { subscriptionType });
    return res.data;
  },

  getSubscriptionUsage: async (): Promise<number> => {
    const { selectedCommunity } = (store.getState() as RootState).application;
    const res = await httpService.get(`/networks/communities/${selectedCommunity}/subscription/usage`);
    return res.data;
  },

  changeSubscription: async (subscriptionType: SubscriptionType): Promise<void> => {
    const { selectedCommunity } = (store.getState() as RootState).application;
    await httpService.put(`/networks/communities/${selectedCommunity}/subscription/`, { subscriptionType });
  },

  cancelSubscription: async (): Promise<void> => {
    const { selectedCommunity } = (store.getState() as RootState).application;
    await httpService.delete(`/networks/communities/${selectedCommunity}/subscription/`);
  },

  getPaymentDetails: async (): Promise<PaymentDetails> => {
    const { selectedCommunity } = (store.getState() as RootState).application;
    const res = await httpService.get(`/networks/communities/${selectedCommunity}/subscription/payment-details`);
    return res.data;
  },

  getLastInvoices: async (limit: number): Promise<InvoiceData[]> => {
    const { selectedCommunity } = (store.getState() as RootState).application;
    const res = await httpService.get(`/networks/communities/${selectedCommunity}/subscription/invoices?limit=${limit}`);
    return res.data;
  },

  getUpcomingInvoice: async (): Promise<InvoiceData> => {
    const { selectedCommunity } = (store.getState() as RootState).application;
    const res = await httpService.get(`/networks/communities/${selectedCommunity}/subscription/invoices/upcoming`);
    return res.data;
  },

  fetchInvoicePdf: async (invoiceId: string): Promise<Blob> => {
    const { selectedCommunity } = (store.getState() as RootState).application;
    return httpService
      .get(`/networks/communities/${selectedCommunity}/subscription/invoices/pdfs/${invoiceId}`, { responseType: 'blob' })
      .then((res) => res.data);
  },

  getEndDate: async (): Promise<number | null> => {
    const { selectedCommunity } = (store.getState() as RootState).application;
    const res = await httpService.get(`/networks/communities/${selectedCommunity}/subscription/end-date`);
    return res.data;
  },

  reactivateSubscription: async () => {
    const { selectedCommunity } = (store.getState() as RootState).application;
    return httpService.put(`/networks/communities/${selectedCommunity}/subscription/reactivate`);
  },
};
